import React from "react";


function Timing() {
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/darsan.png)',backgroundSize:'cover',backgroundPosition:'center'}}></div>
      <div className="container" style={{backgroundImage:'url(./images/event.jpeg)',marginTop:'100px',marginBottom:'100px',padding:'50px',backgroundSize:'cover',backgroundAttachment:'fixed'}}>
        <div className="row" style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
            <div className="col-md-7" style={{background:'#ffeccaf6',padding:'50px'}}>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px',background:'orange'}}>
                    <div className="col-md-12 middle">
                       <center><p className="enquiry">Darshan Timings / ദർശന സമയം</p> </center>                                         
                    </div>
                </div>
                <div className="row" style={{marginBottom:'10px',paddingBottom:'15px',paddingTop:'15px'}}>
                    {/* <center>
                          <h3 className="theading" style={{fontSize:'20px',fontWeight:'700',marginTop:'-20px',textAlign:'center'}}>Alpashi Festival from 16-10-2025 to 31-10-2025</h3>
                      </center> */}
                    {/* first */}
                   
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">6:30 AM to 7:00 AM</li>
                                <li className="timelist">08:30 AM to 10:00 AM</li>
                                <li className="timelist">10:30 AM to 11:15 AM</li>
                                <li className="timelist">After 12:00</li>
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                <li className="timelist">4:30 PM to 6:15 PM</li>
                                <li className="timelist">6:45 PM to 7:20 PM</li>
                                <li className="timelist">After Sreeveli</li>
                                </ul>
                      </div>
                    </div>
                     
                </div>
                
                
           </div> 
                      
        </div>
        <div className="row" style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
            <div className="col-md-7" style={{background:'#ffeccaf6',padding:'50px'}}>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px',background:'orange'}}>
                    <div className="col-md-12 middle">
                       <center><p className="enquiry">ഏകാദശി</p> </center>                                         
                    </div>
                </div>
                <div className="row" style={{marginBottom:'50px',paddingBottom:'15px',paddingTop:'15px'}}>
                    {/* <center>
                          <h3 className="theading" style={{fontSize:'20px',fontWeight:'700',marginTop:'-20px',textAlign:'center'}}>Alpashi Festival from 16-10-2025 to 31-10-2025</h3>
                      </center> */}
                    {/* first */}
                   
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">2:30 AM to 4:00 AM - (നിർമാല്യം, അഭിഷേകം, ദീപാരാധന)</li>
                                <li className="timelist">4:00 AM to 6:00 AM</li>
                                <li className="timelist">09:30 AM to 11:30 AM</li>
                                <li className="timelist">12:00 AM to 01:00 PM</li>
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                <li className="timelist">3:15 PM to 6:15 PM</li>
                                <li className="timelist">രാത്രി ഏകാദശി ശീവേലി 08:15 PM</li>
                                <li className="timelist">രാത്രി 09:15 കഴിഞ്ഞ് ദർശനം ഉണ്ടായിരിക്കുന്നതാണ്.</li>
                                </ul>
                      </div>
                    </div>
                     
                </div>
                
                
           </div> 
                      
        </div>
        
      </div>
    </div>
  );
}

export default Timing;